export default {
    SPLIT_REGEX: /[-_]/g,
};
//# sourceMappingURL=locale.constants.js.map